import type { OnChangeFn, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, RefObject } from "react"
import type { CombinedError } from "urql"

import { useQualityApprovalColumns } from "../hooks/useQualityApprovalColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { QualityApproval } from "@/graphql/codegen/graphql"

interface QualityApprovalTableProps {
  data: QualityApproval[]
  loading?: boolean
  error?: CombinedError | Error
  sorting: SortingState
  containerRef?: RefObject<HTMLDivElement>
  onSortingChange: OnChangeFn<SortingState>
  onScroll?: () => void
  onTestReview: (qualityApproval: QualityApproval) => void
}

export const QualityApprovalTable: FC<QualityApprovalTableProps> = ({
  data,
  error,
  loading = false,
  sorting,
  containerRef,
  onSortingChange,
  onScroll,
  onTestReview,
}) => {
  const columns = useQualityApprovalColumns({ onTestReview })

  return (
    <AerosBaseTable
      error={error}
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            isLoading: loading,
          },
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          onSortingChange,
        },
      }}
      slotProps={{
        container: { ref: containerRef, onScroll },
      }}
      noDataMessage='No pending quality approvals'
    />
  )
}
